import { Stack, Typography } from '@mui/material';
import Chart, { useChart } from '@aibees/shared/components/chart';
import { memo } from 'react';
import * as SX from './sx';
import type { ReportSingleChartProps as Props } from './types';

export const ReportSingleChart = memo(({ value, title, color }: Props) => {
  const chartOptions = useChart([], {
    colors: [color],
    stroke: {
      show: false,
    },
    legend: {
      show: false,
    },
    tooltip: {
      fillSeriesColor: false,
    },

    plotOptions: {
      radialBar: {
        hollow: {
          size: '58%',
        },
        dataLabels: {
          show: false,
        },
      },
    },
  });

  return (
    <Stack direction="row" alignItems="center">
      <Stack sx={SX.chartWrapper}>
        <Chart
          dir="ltr"
          type="radialBar"
          series={[44]}
          options={chartOptions}
          width={180}
        />
        <Typography sx={SX.chartLabel}>{value}%</Typography>
        <Stack sx={SX.info} justifyContent="center" alignItems="flex-start">
          <Typography sx={SX.value}>{value}%</Typography>
          <Typography sx={SX.label}>{title}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
});

ReportSingleChart.displayName = 'ReportSingleChart';
